// const rootUrl = 'http://127.0.0.1:8842';
// const rootUrl = 'http://192.168.0.112:8842';
// const rootUrl = 'http://120.236.105.249:8843';
// const rootUrl = 'https://newtestapi.xiaobaibao.com';//测试环境网关地址
//  const rootUrl = 'https://wxtestapi.xiaobaibao.com';//生产环境网关地址
 const rootUrl = 'https://mtadmin.xiaobaibao.com/api';//生产环境网关新地址
// const rootUrl = 'https://newtest.xiaobaibao.com/api';//测试环境网关新地址

const baseUrl = {
  /**
   * 服务器端口
   */
  rootUrl : rootUrl,
  //登录页面路径
  // loginUrl : "localhost:3001/cloudPlatform-H5/pages/html/dutyInsurance/login.html",//本地
  loginUrl : "xbyf.xiaobaibao.com/old/html/dutyInsurance/login.html",//正式
  // loginUrl : "xbyftest.xiaobaibao.com/old/html/dutyInsurance/login.html",//测试
  //关税投保路径
  // tariffUrl : "localhost:3001/cloudPlatform-H5/pages/html/dutyInsurance/fillInfo.html"//本地
  tariffUrl : "xbyf.xiaobaibao.com/old/html/dutyInsurance/fillInfo.html"//正式
  // tariffUrl : "xbyftest.xiaobaibao.com/old/html/dutyInsurance/fillInfo.html"//测试
};

export default baseUrl;



// WEBPACK FOOTER //
// ./src/tool/baseUrl.js